import { faReply } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const ActionPanel = ({ handleReply }) => {
  return (
    <div className="absolute right-0 top-0 flex gap-1 items-center p-[3px]">
      <button
        onClick={handleReply}
        title="Reply to message"
        className="button-outline flex items-center justify-center p-[3px] rounded-full bg-neutral-100 dark:bg-neutral-900"
      >
        <FontAwesomeIcon className="size-2.5" icon={faReply} />
      </button>
    </div>
  )
}

ActionPanel.propTypes = {
  handleReply: PropTypes.func.isRequired
}

export default ActionPanel
